import React, { Component } from 'react';
import {Col, Row} from 'react-bootstrap';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import Modal from '../../../components/modal';
import Preloader from '../../../components/preloader';
import EmptyState from '../../../components/empty-state-container';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';

import {connect} from 'react-redux';

let queryList;

class ManageQueries extends Component {

  constructor(props) {
    super(props);
    this.state = {
      menuAnchorEl: null,
      menuOpenId: null,
      userFilterCriteria:"",
      emptyState:"You do not have any saved queries.",
      deleteQueryVal:"",
      modalOpen:false,
      modalTitle:"",
      modalContent:"",
      modalPrimaryButton:"",
      modalSecondaryButton:""
    };
  }


componentDidMount=()=>{
  this.setState({
    userFilterCriteria:""
  });
}




editQuery = (qy) => {
    //this.props.getRuleSetContent("edit-account");
    this.props.onClick({qy});
}

modalClose=()=>{
  this.setState({
    modalOpen:false
  });
}

modalConfirm=()=>{

  this.setState({
    modalOpen:false
  });
  let deleteObj={
      dbConnectionId:this.state.deleteQueryVal.dbId,
      dbQryId:this.state.deleteQueryVal.queryId,
      dbQryName:this.state.deleteQueryVal.name
  }
  this.props.deleteQuery(deleteObj);
}

deleteItem = (qy) => {
    //this.props.getRuleSetContent(value);
    //this.props.onClick(value);
    this.setState({
      modalOpen:true,
      modalTitle:"Delete Query",
      modalContent:"Are you sure you want to delete \""+qy.name+"\"?",
      modalPrimaryButton:"Yes",
      modalSecondaryButton:"No",
      modalState:"delete",
      deleteQueryVal:qy
    });
}

  createNewQuery = () => {

    this.props.onClick('new');

}





   render() {






     const {isLoading} = this.props;
     let manageQueriesContent,queryListContent;

     if(isLoading.includes('querylist')){
       manageQueriesContent=<Preloader loading={true} /> ;
     }
     else if(this.props.queriesList !== undefined){

      const filterCriteria=this.state.userFilterCriteria;
      queryList = this.props.queriesList.filter(function (e) {  return e.name.toLowerCase().includes(filterCriteria.toLowerCase()); } );


      if(queryList.length>0){
        queryListContent=<table className='manage-ruleset-table'>
        <tbody>
             {queryList.map((query,index) => <tr key={index}>
               <td onClick={this.editQuery.bind(this,query)} className='user' > {query.name+" ("+query.dbConnName+")"}</td>
               <td>
               <div>
  <IconButton onClick={(e) => this.setState({ menuAnchorEl: e.currentTarget, menuOpenId: index })}><i className='material-icons'>more_horiz</i></IconButton>
  <Menu anchorEl={this.state.menuAnchorEl} open={Boolean(this.state.menuAnchorEl) && this.state.menuOpenId === index} onClose={() => this.setState({ menuAnchorEl: null, menuOpenId: null })}>
                   <MenuItem className='wl-group-card-menu'
                   onClick={this.deleteItem.bind(this,query)}>Delete</MenuItem>
               </Menu>
</div>
                </td>
               </tr>)}
       </tbody>
        </table>
      }else{
        queryListContent=<EmptyState className="margin-top-0" message={this.state.emptyState} />
      }
       manageQueriesContent=<Row>

       <Col sm={4} xs={6}>{queryListContent}</Col>
       <Col sm={4} xs={6} className="manage-rule-buttons">

          <Button href=""  onClick={this.createNewQuery.bind(this)} className='createruleset-button'>Add a new query</Button>
       </Col>

       </Row>
     }

     return (
       <div>
       <Modal
        open={this.state.modalOpen}
        title={this.state.modalTitle}
        content={this.state.modalContent}
        primaryButton={this.state.modalPrimaryButton}
        secondaryButton={this.state.modalSecondaryButton}
        close={this.modalClose}
        confirm={this.modalConfirm}
        />
       <div className="manage-ruleset margin-top-30"> {manageQueriesContent} </div>
      </div>

     );
   }
}


const mapStateToProps = (state) => {
  return{
    errors: state.databaseReducer.errorMessage
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {

  }
}


export default connect(mapStateToProps,mapDispatchToProps) (ManageQueries);
